import { useEffect, useMemo } from "react";
import { applySeoTags, getTitleWithBase, sanitizeSeoText } from "./titleUtils";

const buildRouteSeo = ({ pathname, tenantStyles }) => {
  const baseTitle = sanitizeSeoText(tenantStyles?.pageTitle || "");
  const baseDescription = sanitizeSeoText(tenantStyles?.description || "");

  if (!pathname) {
    return { title: baseTitle, description: baseDescription };
  }

  return {
    title: baseTitle,
    description: baseDescription,
  };
};

export const useRouteSeo = ({ pathname, tenantStyles }) => {
  const routeSeo = useMemo(
    () => buildRouteSeo({ pathname, tenantStyles }),
    [pathname, tenantStyles]
  );

  useEffect(() => {
    if (!tenantStyles?.pageTitle) return;

    applySeoTags(routeSeo);
  }, [routeSeo, tenantStyles]);
};

export const usePageSeo = ({ title, description, tenantStyles }) => {
  const seoPayload = useMemo(() => {
    const computedTitle = getTitleWithBase(title, tenantStyles);
    const computedDescription = sanitizeSeoText(description || tenantStyles?.description || "");

    return {
      title: computedTitle,
      description: computedDescription,
    };
  }, [title, description, tenantStyles]);

  useEffect(() => {
    if (!seoPayload.title) return;

    applySeoTags(seoPayload);
  }, [seoPayload]);
};
